/* MD Preguntas frecuentes: animación de apertura y cierre del acordeón nativo */
(function () {
  'use strict';

  var DURACION = 280;
  var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');

  function alturaCerrado(item) {
    return item.querySelector('.md-faq__question').offsetHeight;
  }

  function animar(item, desde, hasta, alFinal) {
    if (reducirMovimiento.matches || typeof item.animate !== 'function') {
      alFinal();
      return;
    }
    item.dataset.mdAnimando = 'true';
    item.style.overflow = 'hidden';
    item.style.height = desde + 'px';
    var animacion = item.animate(
      { height: [desde + 'px', hasta + 'px'] },
      { duration: DURACION, easing: 'ease-out' }
    );
    var terminado = false;
    function terminar() {
      if (terminado) return;
      terminado = true;
      item.style.height = '';
      item.style.overflow = '';
      delete item.dataset.mdAnimando;
      alFinal();
    }
    animacion.onfinish = animacion.oncancel = terminar;
    /* Si el navegador congela la animación (pestaña en segundo plano), se remata igualmente */
    setTimeout(function () {
      if (!terminado) animacion.cancel();
    }, DURACION + 200);
  }

  function abrir(item) {
    var desde = alturaCerrado(item);
    item.open = true;
    var hasta = item.offsetHeight;
    animar(item, desde, hasta, function () {
      item.querySelector('.md-faq__answer').classList.add('md-faq__answer--visible');
    });
  }

  function cerrar(item) {
    var desde = item.offsetHeight;
    var hasta = alturaCerrado(item);
    item.querySelector('.md-faq__answer').classList.remove('md-faq__answer--visible');
    animar(item, desde, hasta, function () {
      item.open = false;
    });
  }

  function initSection(container) {
    if (container.dataset.mdInit) return;
    container.dataset.mdInit = 'true';
    container.classList.add('md-faq--js');

    var items = container.querySelectorAll('.md-faq__item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].open) {
        items[i].querySelector('.md-faq__answer').classList.add('md-faq__answer--visible');
      }
    }

    container.addEventListener('click', function (e) {
      var summary = e.target.closest('.md-faq__question');
      if (!summary || !container.contains(summary)) return;
      var item = summary.parentElement;
      e.preventDefault();
      if (item.dataset.mdAnimando) return;
      if (item.open) {
        cerrar(item);
      } else {
        abrir(item);
      }
    });
  }

  var sections = document.querySelectorAll('.md-faq');
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.md-faq');
    if (section) initSection(section);
  });
})();
